import { gql } from "@apollo/client"

export const ENABLE_DISABLE_KOL_PROFILE = gql`
  mutation approveKolProfile($kolProfileId: uuid!, $isApproved: Boolean, $isActive: Boolean) {
    update_kol_profile_by_pk(pk_columns: { id: $kolProfileId }, _set: { is_active: $isActive, is_approved: $isApproved }) {
      id
      is_active
      is_approved
    }
  }
`
